import styled from 'styled-components';

export const StyledChatContainer = styled.div<{ chatOpen: boolean }>`
  position: fixed;
  top: 0;
  right: ${({ chatOpen }) => (chatOpen ? "0" : "-100%")}; /* Animate from offscreen to view */
  width: 380px;
  height: 100%;
  background-color: #284121;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: right 0.3s ease-in-out; /* Smooth animation */
  z-index: 3;
`;

export const StyledChatHeader = styled.div`
    display: flex;
    flex-direction: row;
    -webkit-box-pack: center;
    justify-content: end;
    -webkit-box-align: end;
    align-items: center;
    padding: 0px 30px;
    height: 100px;
    background-color: rgb(33, 55, 27);
    box-sizing: border-box;
    position: absolute;
    width: 100%;
`

export const StyledChatWidgets = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 200px);
    padding-top: 100px;
    padding-bottom: 100px;
    padding-right: 10px;
    overflow-y: auto;
`

export const StyledChatWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 10px;

    & .chat_content {
        background-color: #2C523C;
        border-radius: 10px;
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
        word-break: break-word;
    }
`

export const StyledChatContent= styled.h5`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin: 0;
    color: white

    &.
`

export const StyledChatFooter = styled.div`
    display: flex;
    flex-direction: row;
    -webkit-box-pack: center;
    justify-content: end;
    -webkit-box-align: end;
    align-items: center;
    padding: 0px 30px;
    height: 100px;
    background-color: rgb(33, 55, 27);
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    bottom: 0;

    p {
        color: white;
        text-align: center;
        width: 100%;
    }
`